module.exports = __webpack_public_path__ + "static/media/car-date.d91bdecd.svg";